
import { useI18n } from '../../i18n'
import { isPlatform } from '../../utils'
import { FocusableProvider, FocusGroupProvider } from '../focus'
import './QuitPopUp.css'

interface IQuitPopUp {
    updateLogoutStatus: (flag: boolean, buttonName?: string, ) => void
}

const QuitPopUp = (props: IQuitPopUp) => {
    const { getI18n } = useI18n()

    const closeApplication = () => {
        if (isPlatform('tizen')) {
            if (window?.tizen) {
                window?.tizen?.application.getCurrentApplication().exit();
                window.close()
            } else {
                window?.parent?.postMessage?.('exit', 'file://')
            }
        } else {
            window.close()
        }
    }
    return (
        <div class='quit-popup-wrapper'>
            <div class="quit-popup-container">
                <div class='quit-header-container'>
                    <p>
                        <span>{getI18n()?.formatMessage({ id: 'EXIT_APP' })}</span>
                    </p>
                </div>
                <FocusGroupProvider
                    id={`logout-page-focus-group`}
                    focusKey={'logout-page-focus-group'}
                    class='quit-popup-data-container'
                    isFocusBoundary={true}
                >
                    <div>
                        <div class='quit-popup-description'>
                            <p>
                                <span>{getI18n()?.formatMessage({ id: 'EXIT_CONFIRM_DESC' })}</span>
                            </p>
                        </div>

                        <div style={{ "flex-direction": 'row', 'display': 'flex', "justify-content": 'center' }}>
                            <FocusableProvider
                                focusKey={`confirm`}
                                onFocus={() => {
                                    document.getElementById('confirm')?.focus()
                                }}
                                onEnterPress={async () => {
                                    closeApplication()
                                }}
                            >
                                {(focused: any) => (
                                    <button id="confirm"
                                        onClick={async () => {
                                            closeApplication()
                                        }}
                                        class={`action-button ${focused?.() ? 'action-button-focused' : ''}`}>
                                        {getI18n()?.formatMessage({ id: 'YES' })}
                                    </button>
                                )}
                            </FocusableProvider>
                            <FocusableProvider
                                focusKey={`cancel`}
                                onFocus={() => {
                                    document.getElementById('cancel')?.focus()
                                }}
                                onEnterPress={async () => {
                                    props?.updateLogoutStatus(false)
                                }}
                            >
                                {(focused: any) => (
                                    <button id="cancel"
                                        onClick={async () => {
                                            props?.updateLogoutStatus(false)
                                        }}
                                        class={`action-button ${focused?.() ? 'action-button-focused' : ''}`}>
                                        {getI18n()?.formatMessage({ id: 'NO' })}
                                    </button>
                                )}
                            </FocusableProvider>

                        </div>
                    </div>
                </FocusGroupProvider>
            </div>
        </div>
    )
}

export default QuitPopUp
